import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { mainurl } from '../../MainUrl';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import { Row, Col, Card, CardBody, Spinner, Button, Input, Label, FormGroup } from 'reactstrap';
import { notification } from '../../component/hocs/notification';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';



const ViewBatch = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());  // Default to today's date
const [toDate, setToDate] = useState(new Date());

  const [batchStatus, setBatchStatus] = useState('');

  const formatDateForDisplay = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  const formatDateForBackend = (date) => {
    if (!date || isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;  // Correct format for backend
  };
  

  // Fetch all batch data initially
  const getBatchData = () => {
    setLoading(true);
    axios
      .get(mainurl + 'view_batch')
      .then((response) => {
        console.log('Initial batch data response:', response.data);
        if (response.data && response.data.data) {
          let serialNumber = 1;
          const batchData = response.data.data.map((item) => {
            let batchStatus = 'N/A'; // Default value if no status found
  
            // Directly check batch_status value
            if (item.batch_status === 1) {
              batchStatus = 'Running'; // 1 means batch is started
            } else if (item.batch_status === 2) {
              batchStatus = 'Closed'; // 2 means batch is closed
            }
  
            return {
              sl: serialNumber++, 
              batch_no: item.batch_no || 'N/A',
              machine_no: item.machine_no || 'N/A',
              raw_material_name: item.raw_material_name ? `${item.raw_material_name} ${item.raw_quantity} ${item.raw_uom}` : 'No Name Available',
              finished_product_name: item.finished_product_name ? `${item.finished_product_name} ${item.finished_quantity} ${item.finished_uom}` : 'No Name Available',
              start_date: item.start_date 
    ? `${formatDate(item.start_date)} ${item.start_time || ''}` 
    : 'No Date Available', // Combine start_date and start_time
  end_date: item.end_date 
    ? `${formatDate(item.end_date)} ${item.end_time || ''}` 
    : 'No Date Available', // Combine end_date and end_time
              batch_status: batchStatus, // Display batch status as 'Start' or 'Closed'
            };
          });
          setTableData(batchData);
        } else {
          notification('error', 'Invalid data format');
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching batch data:', error);
        setLoading(false);
        notification('error', 'Failed to fetch batch data');
      });
  };
  
  // Fetch batch data based on filters (POST request)
  const searchBatchStatus = () => { 
    console.log('Request body:', { from_date: fromDate, to_date: toDate, batch_status: batchStatus });

    if (!fromDate || !toDate) {
      notification('warning', 'Please fill in all fields');
      return;
    }

    setLoading(true);
    setTableData([]);  // Clear previous data

    // Ensure batchStatus is a number (0 for "All")
    const requestBody = {
      from_date: formatDateForBackend(fromDate),
      to_date: formatDateForBackend(toDate),
      batch_status: batchStatus === 'all' ? 0 : Number(batchStatus),  // Convert 'all' to 0, others to Number
    };

    console.log('Sending request with body:', requestBody);  // Log the request body

    axios
      .post(mainurl + 'batch_status', requestBody)
      .then((response) => {
        if (response.data && response.data.data && response.data.data.length > 0) {
          let serialNumber = 1;

          const batchData = response.data.data.map((item) => ({
            sl: serialNumber++,
            batch_no: item.batch_no || 'N/A',
            machine_no: item.machine_no || 'N/A',
            raw_material_name: item.raw_material_name ? `${item.raw_material_name} ${item.raw_quantity} ${item.raw_uom}` : 'No Name Available',
            finished_product_name: item.finished_product_name ? `${item.finished_product_name} ${item.finished_quantity} ${item.finished_uom}` : 'No Name Available',
            start_date: item.start_date 
    ? `${formatDate(item.start_date)} ${item.start_time || ''}` 
    : 'No Date Available', // Combine start_date and start_time
  end_date: item.end_date 
    ? `${formatDate(item.end_date)} ${item.end_time || ''}` 
    : 'No Date Available', // Combine end_date and end_time
            batch_status: item.batch_status === 'Running' ? 'Running' : item.batch_status === 'Closed' ? 'Closed' : 'N/A',
          }));

          setTableData(batchData);
        } else {
          notification('warning', 'No data found for the selected batch status');
          setTableData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching batch status data:', error);
        setLoading(false);
        notification('error', 'Failed to fetch batch status data');
      });
};

  
  
  

  

  // Format date to DD/MM/YYYY
  const formatDate = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const year = newDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    getBatchData();
  }, []);

  const customTableStyles = {
    rows: { highlightOnHover: true },
    headCells: {
      style: { fontWeight: 'bold', backgroundColor: '#FF0000', color: 'white' },
    },
    cells: { style: { padding: '10px' } },
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-1">
            <Title pageTitle="View Batch Data" />
          </Col>
  
          <Col xs={12} className="mb-3">
            <Card color="primary" outline>
              <CardBody>
                <Row>
                  <FormGroup row>
                  <Label for="fromDate" sm={2}>From Date</Label>
<Col sm={4}>
  <DatePicker
    selected={fromDate}
    onChange={(date) => setFromDate(date)}
    dateFormat="dd/MM/yyyy"
    placeholderText="Select From Date"
    className="form-control"
    isClearable
  />
</Col>

<Label for="toDate" sm={2}>To Date</Label>
<Col sm={4}>
  <DatePicker
    selected={toDate}
    onChange={(date) => setToDate(date)}
    dateFormat="dd/MM/yyyy"
    placeholderText="Select To Date"
    className="form-control"
    isClearable
  />
</Col>


                  </FormGroup>
  
                  <FormGroup row>
                    <Label sm={2}>Batch Status</Label>
                    <Col sm={4}>
                      <Input 
                        type="select" 
                        value={batchStatus} 
                        onChange={(e) => setBatchStatus(e.target.value)}
                      >
                        <option value="">Select Status</option>
                        <option value="0">All</option>  {/* Changed from "all" to "0" */}
                        <option value="1">Running</option>
                        <option value="2">Closed</option>
                      </Input>
                    </Col>
                  </FormGroup>
  
                  <Col md={3} className="d-flex align-items-end">
                    <Button color="primary" onClick={searchBatchStatus}>Search</Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
  
          <Col xs={12}>
            <Card color="primary" outline>
              <CardBody>
                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <DataTable
                    customStyles={customTableStyles}
                    columns={[
                      { name: 'SL No', selector: (row) => row.sl, width: '100px', center: true },
                      { name: 'Batch No', selector: (row) => row.batch_no, wrap: true, center: true },
                      { name: 'Machine No', selector: (row) => row.machine_no, wrap: true, center: true },
                      { name: 'Raw Material Name', selector: (row) => row.raw_material_name, wrap: true, center: true },
                      { name: 'Finished Product Name', selector: (row) => row.finished_product_name, wrap: true, center: true },
                      { name: 'Start Date', selector: (row) => row.start_date, wrap: true, center: true },
                      { name: 'End Date', selector: (row) => row.end_date, wrap: true, center: true },
                      { name: 'Batch Status', selector: (row) => row.batch_status, wrap: true, center: true },
                    ]}
                    data={tableData}
                    keyField="sl"
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
  
};

export default ViewBatch;
